import React, { useRef, useEffect } from 'react';

export default function EditableText({
  value = '',
  onChange,
  className = '',
  multiline = false,
  placeholder = '',
  as: Tag = 'span',
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerText !== value) {
      ref.current.innerText = value || '';
    }
  }, [value]);

  const handleBlur = () => {
    if (ref.current && onChange) {
      const newValue = ref.current.innerText;
      if (newValue !== value) onChange(newValue);
    }
  };

  const handleKeyDown = (e) => {
    if (!multiline && e.key === 'Enter') {
      e.preventDefault();
      e.target.blur();
    }
  };

  return (
    <Tag
      ref={ref}
      contentEditable
      suppressContentEditableWarning
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      data-placeholder={placeholder}
      className={`editable-field ${className}`}
      dir="auto"
    />
  );
}
